import React, { ReactNode } from "react"
import { Trans } from "react-i18next"

import ErrorBoundary from "./ErrorBoundary"

export class LayoutErrorBoundary extends ErrorBoundary {
	protected captureError = true

	public canHandleError(error: Error): boolean {
		return true
	}

	static getDerivedStateFromError(error: Error) {
		return {
			hasError: true,
		}
	}

	public renderOnError(): ReactNode {
		return (
			<>
				<h2>
					<Trans ns="error" key="layoutErrorBoundary.title">
						Error
					</Trans>
				</h2>
				<p>
					<Trans ns="error" key="layoutErrorBoundary.description">
						An unexpected error occurred on the page you were using.
						<br />
						The issue was automatically reported to technical staff
						and will be resolved as soon as possible.
					</Trans>
				</p>
			</>
		)
	}
}
